<template lang="pug">
  div#app.columns.is-centered
    div.column.is-11
      router-view
</template>

<script>
export default {
  name: 'mcr-web-app',  
}
</script>

/*
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #E8E8E8;
  margin-top: 0px;
  padding-top: 2vh;
}
</style>
*/
<style lang="sass">
  
  @import '~bulma'
</style>

